module.exports = __webpack_public_path__ + "static/media/Slice22@2x.6185332d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice22@2x.png
// module id = 1450
// module chunks = 0